module.exports = __webpack_public_path__ + "img/snowflake.bd967a24.png";